import { SERVICE_NAME } from "@/config/serviceNames";
import { requests } from ".";

const IntegrationsService = {
  getPaymentPlans: (id: string) =>
    requests(SERVICE_NAME.INTEGRATIONS_API).get(`public/${id}/payment-plans`),

  deleteReviewRequest: (requestId: string) =>
    requests(SERVICE_NAME.INTEGRATIONS_API).delete(
      `gmb/support/review/${requestId}`
    ),

  deleteReviewReplies: (reviewId: string) =>
    requests(SERVICE_NAME.INTEGRATIONS_API).put(
      `gmb/support/review/${reviewId}/replies`
    ),

  getGmbConnectedLocations: (locationId: string) =>
    requests(SERVICE_NAME.INTEGRATIONS_API).get(
      `gmb/support/search?locationId=${locationId}`
    ),

  deleteGmbIntegration: (locationId: string) =>
    requests(SERVICE_NAME.INTEGRATIONS_API).delete(`gmb/support`, {
      data: { locationId },
    }),

  deleteGmbIntegrationByPlacesId: (placesId: string) =>
    requests(SERVICE_NAME.INTEGRATIONS_API).delete("gmb/support/placeId", {
      data: { placesId },
    }),
};

export default IntegrationsService;
